import React from 'react';
import Recaptcha from 'react-google-recaptcha';

export const buildGetRecaptchaTokenByRef =
  (recaptchaRef: React.MutableRefObject<Recaptcha | null>) => async (): Promise<string | null> => {
    if (!recaptchaRef.current) {
      return null;
    }

    try {
      const token = await recaptchaRef.current.executeAsync();
      recaptchaRef.current.reset();
      return token;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
